import { applyMiddleware, combineReducers, createStore } from 'redux';
import createSagaMiddleware from 'redux-saga';
import { getAsyncReducers } from 'react-async-client';
import { persistStore, persistReducer, createTransform } from 'redux-persist';
import storage from 'redux-persist/es/storage';

import rootReducer from '../reducers/rootReducer';
import rootSaga from '../sagas/index';
import { pushRollbarError } from 'utils/rollbar';

const SetTransform = createTransform(
    (inboundState, key) => {
        if (key === 'leftMenu') {
            const { leftMenuPinned } = inboundState;

            if (leftMenuPinned) {
                return {...inboundState, leftMenuCollapsed: false }
            } else {
                return {...inboundState, leftMenuCollapsed: true }
            }
        }
      return inboundState;
    },
  );

const sagaMiddleware = createSagaMiddleware({
    onError: pushRollbarError,
});
let middlewares = [sagaMiddleware];

if (process.env.NODE_ENV !== 'production') {
    const createLogger = require('redux-logger').createLogger;
    const logger = createLogger({ collapsed: true });
    middlewares.push(logger);
}

if (process.env.NODE_ENV === 'production') {
    const rollbar = require('./rollbarMiddleware').default;
    middlewares.push(rollbar);
}

const persistConfig = {
    key: 'experium',
    storage,
    whitelist: [
        'calendar',
        'leftMenu',
        'notification',
        'colorScheme',
    ],
    transforms: [SetTransform]
};

const mainReducer = combineReducers({
    ...getAsyncReducers(),
    ...rootReducer,
});

const reducer = persistReducer(persistConfig, mainReducer);

export default function configureStore(initialState) {
    const Store = createStore(
        reducer,
        initialState,
        applyMiddleware(...middlewares)
    );
    const Persistor = persistStore(Store);
    sagaMiddleware.run(rootSaga);
    return { Store, Persistor, sagaMiddleware };
}
